import styles from "../css/component_css/PlansContainer.module.css";
import { useMemo, useState } from "react";
import RegistrationTriosContainer from "./RegistrationTriosContainer";

const PlansContainer = ({ }) => {

  const [isOpenPopup, setIsOpenPopup] = useState(false);
  const [choosenPackage, setChoosenPackage] = useState(1)
    const encryptions = [
        {
            title: "Máy chủ",
            content1: "Sử dụng máy chủ Global",
            content2: "Sử dụng máy chủ dùng riêng cho tổ chức",
        },
        {
            title: "Công nghệ mã hoá",
            content1:
                "Sử dụng công nghệ mã hoá đầu cuối (E2EE) đảm bảo không một bên thứ 3 nào có thể giải mã được tin nhắn kể cả đơn vị cung cấp dịch vụ.",
            content2:
                "Sử dụng công nghệ mã hoá đầu cuối (E2EE) đảm bảo không một bên thứ 3 nào có thể giải mã được tin nhắn kể cả đơn vị cung cấp dịch vụ.",
        },
        {
            title: "Thuật toán mã hoá",
            content1: "Sử dụng mã hoá tiêu chuẩn AES",
            content2: "Sử dụng thuật toán mã hoá MKV",
        },
        {
            title: "Tích hợp thuật toán mã hoá chuyên biệt",
            content1: "Không tích hợp thuật toán mã hoá khác.",
            content2:
                "Cho phép tích hợp thuật toán mã hoá chuyên biệt do Ban Cơ yếu Chính phủ cung cấp dùng để truyền tải nội dung mật đến tối mật.",
        },
        {
            title: "Số lượng người dùng trong kênh/nhóm",
            content1:
                "Hạn chế số người dùng trong cùng kênh/nhóm, tối đa 20 người.",
            content2:
                "Không hạn chế số lượng người dùng trong cùng một kênh/nhóm",
        },
        {
            title: "Tính năng conference",
            content1: "Không hỗ trợ tính năng conference",
            content2: "Hỗ trợ tính năng conference",
        },
        {
            title: "Dung lượng gửi file",
            content1: "Dung lượng gửi file tối đa 100MB",
            content2: "Dung lượng file được quy định bởi tổ chức",
        },
        {
            title: "Tích hợp ứng dụng nghiệp vụ",
            content1:
                "Không hỗ trợ tích hợp với các ứng dụng nghiệp vụ.",
            content2:
                "Hỗ trợ tích hợp với các ứng dụng nghiệp vụ trong tổ chức.",
        },
        {
            title: "Hỗ trợ quản lý",
            content1: "Được quản lý bởi nhà cung cấp dịch vụ.",
            content2: "Hỗ trợ kỹ thuật 24/7",
        },
    ];

  return (
    <div className={styles.plans}>
      <div className={styles.plan4}>
        <div className={styles.frameParent}>

          <div className={styles.planParent}>
            <div className={styles.plan}>
              <div className={styles.polygonParent}>
                <img
                  className={styles.frameChild}
                  alt=""
                  src="../polygon-71.svg"
                />
                <b className={styles.dngThMin}>Miễn phí</b>
              </div>
              <b className={styles.giCBn}>Khách hàng cá nhân</b>
              <div className={styles.triNghimMin}>
                Trải nghiệm miễn phí Trios - giải pháp thông tin liên lạc mà bạn
                đang tìm kiếm
              </div>
            </div>


            {/*<div className={styles.buttonDesktop}>*/}
            {/*  <a onClick={() => {*/}
            {/*    setChoosenPackage(1)*/}
            {/*    setIsOpenPopup(true)*/}
            {/*  }}>*/}
            {/*    /!*<div className={styles.buttonDesktop1}>*!/*/}
            {/*    /!*  <b className={styles.tiTrios}>Đăng ký ngay</b>*!/*/}
            {/*    /!*  <img*!/*/}
            {/*    /!*    className={styles.chevronRightIcon}*!/*/}
            {/*    /!*    alt=""*!/*/}
            {/*    /!*    src="../chevronright1.svg"*!/*/}
            {/*    /!*  />*!/*/}
            {/*    /!*</div>*!/*/}
            {/*  </a>*/}
            {/*</div>*/}
          </div>
          <div className={styles.feature}>
            <div className={styles.infor3Parent}>
                <div className={styles.wrapper}>
                    {encryptions.map((item, index) => (
                        <div key={index} className={styles.row}>
                            {/* Cột title */}

                            {/* Cột content 1 */}
                            <div className={styles.infor3}>
                                <img
                                    className={styles.checkmarkCircleIcon}
                                    alt=""
                                    src="../checkmarkcircle.svg"
                                />
                                <div className={styles.phng702}>{item.content1}</div>
                            </div>


                        </div>
                    ))}
                </div>


              <div className={styles.infor9Parent}>



              </div>
            </div>
            <b className={styles.tmHiuThm}>Tìm hiểu thêm</b>
          </div>
        </div>
      </div>
      <div className={styles.plan2}>
        <div className={styles.frameParent}>
          <div className={styles.planParent}>
            <div className={styles.plan}>
              <div className={styles.polygonParent}>
                <img
                  className={styles.frameChild}
                  alt=""
                  src="../polygon-71.svg"
                />
                <b className={styles.dngThMin}>Liên hệ</b>
              </div>
              <b className={styles.giCBn}>Khách hàng tổ chức</b>
              <div className={styles.triNghimMin}>
                  Phù hợp với các doanh nghiệp, tổ chức, cơ quan ban ngành có yêu cầu bảo mật an toàn thông tin cao và độc lập dữ liệu tại đơn vị.
              </div>
            </div>
            {/*<div className={styles.buttonDesktop}>*/}
            {/*  <a onClick={() => {*/}
            {/*    setChoosenPackage(2)*/}
            {/*    setIsOpenPopup(true)*/}
            {/*  }}>*/}
            {/*    /!*<div className={styles.buttonDesktop1}>*!/*/}
            {/*    /!*  <b className={styles.tiTrios}>Đăng ký ngay</b>*!/*/}
            {/*    /!*  <img*!/*/}
            {/*    /!*    className={styles.chevronRightIcon}*!/*/}
            {/*    /!*    alt=""*!/*/}
            {/*    /!*    src="../chevronright1.svg"*!/*/}
            {/*    /!*  />*!/*/}
            {/*    /!*</div>*!/*/}
            {/*  </a>*/}
            {/*</div>*/}
          </div>
          <div className={styles.feature}>
            <div className={styles.infor3Group}>
                <div >
                    {encryptions.map((item, index) => (
                        <div key={index}>
                            {/* Cột title */}

                            {/* Cột content 1 */}
                            <div className={styles.infor3}>
                                <img
                                    className={styles.checkmarkCircleIcon}
                                    alt=""
                                    src="../checkmarkcircle5.svg"
                                />
                                <div className={styles.phng702}>{item.content2}</div>
                            </div>


                        </div>
                    ))}
                </div>

            </div>
            <b className={styles.tmHiuThm}>Tìm hiểu thêm</b>
          </div>
        </div>
      </div>
      {/*<div className={styles.plan3}>*/}
      {/*  <div className={styles.frameParent}>*/}
      {/*    <div className={styles.planParent}>*/}
      {/*      <div className={styles.plan}>*/}
      {/*        <div className={styles.polygonParent}>*/}
      {/*          <img*/}
      {/*            className={styles.frameChild}*/}
      {/*            alt=""*/}
      {/*            src="../polygon-71.svg"*/}
      {/*          />*/}
      {/*          <b className={styles.dngThMin}>Liên hệ</b>*/}
      {/*        </div>*/}
      {/*        <b className={styles.giCBn}>Gói nâng cao</b>*/}
      {/*        <div className={styles.triNghimMin}>*/}
      {/*          Phù hợp với doanh nghiệp lớn, khối lượng thông tin trao đổi*/}
      {/*          nhiều, lưu trữ thông tin dài hạn*/}
      {/*        </div>*/}
      {/*      </div>*/}
      {/*      <div className={styles.buttonDesktop}>*/}
      {/*        <a onClick={() => {*/}
      {/*          setChoosenPackage(3)*/}
      {/*          setIsOpenPopup(true)*/}
      {/*        }}>*/}
      {/*          /!*<div className={styles.buttonDesktop1}>*!/*/}
      {/*          /!*  <b className={styles.tiTrios}>Đăng ký ngay</b>*!/*/}
      {/*          /!*  <img*!/*/}
      {/*          /!*    className={styles.chevronRightIcon}*!/*/}
      {/*          /!*    alt=""*!/*/}
      {/*          /!*    src="../chevronright1.svg"*!/*/}
      {/*          /!*  />*!/*/}
      {/*          /!*</div>*!/*/}
      {/*        </a>*/}
      {/*      </div>*/}
      {/*      <RegistrationTriosContainer open={isOpenPopup} onClose={() => setIsOpenPopup(false)} initialPackage={choosenPackage} />*/}
      {/*    </div>*/}
      {/*    <div className={styles.feature}>*/}
      {/*      <div className={styles.infor3Group}>*/}
      {/*        <div className={styles.infor31}>*/}
      {/*          <img*/}
      {/*            className={styles.checkmarkCircleIcon}*/}
      {/*            alt=""*/}
      {/*            src="../checkmarkcircle13.svg"*/}
      {/*          />*/}
      {/*          <div className={styles.phng702}>*/}
      {/*            Mã hoá thông tin tiêu chuẩn*/}
      {/*          </div>*/}
      {/*        </div>*/}
      {/*        <div className={styles.infor31}>*/}
      {/*          <img*/}
      {/*            className={styles.checkmarkCircleIcon}*/}
      {/*            alt=""*/}
      {/*            src="../checkmarkcircle13.svg"*/}
      {/*          />*/}
      {/*          <div className={styles.phng702}>*/}
      {/*            Gửi các file tài liệu doc, pdf, image,...*/}
      {/*          </div>*/}
      {/*        </div>*/}
      {/*        <div className={styles.infor31}>*/}
      {/*          <img*/}
      {/*            className={styles.checkmarkCircleIcon}*/}
      {/*            alt=""*/}
      {/*            src="../checkmarkcircle13.svg"*/}
      {/*          />*/}
      {/*          <div className={styles.phng702}>*/}
      {/*            Nhắn tin trực tiếp với đối tác*/}
      {/*          </div>*/}
      {/*        </div>*/}
      {/*        <div className={styles.infor3}>*/}
      {/*          <img*/}
      {/*            className={styles.checkmarkCircleIcon}*/}
      {/*            alt=""*/}
      {/*            src="../checkmarkcircle13.svg"*/}
      {/*          />*/}
      {/*          <div className={styles.phng702}>*/}
      {/*            <span>Thời gian lưu trữ</span>*/}
      {/*            <span className={styles.ngy}> không giới hạn</span>*/}
      {/*          </div>*/}
      {/*        </div>*/}
      {/*        <div className={styles.infor3}>*/}
      {/*          <img*/}
      {/*            className={styles.checkmarkCircleIcon}*/}
      {/*            alt=""*/}
      {/*            src="../checkmarkcircle13.svg"*/}
      {/*          />*/}
      {/*          <div className={styles.phng702}>*/}
      {/*            <span>Dung lượng lưu trữ</span>*/}
      {/*            <span className={styles.ngy}> 10GB</span>*/}
      {/*          </div>*/}
      {/*        </div>*/}
      {/*        <div className={styles.infor9Group}>*/}
      {/*          <div className={styles.infor91}>*/}
      {/*            <img*/}
      {/*              className={styles.checkmarkCircleIcon}*/}
      {/*              alt=""*/}
      {/*              src="../checkmarkcircle13.svg"*/}
      {/*            />*/}
      {/*            <div className={styles.phng702}>Gọi trực tuyến, video</div>*/}
      {/*          </div>*/}
      {/*          <div className={styles.infor91}>*/}
      {/*            <img*/}
      {/*              className={styles.checkmarkCircleIcon}*/}
      {/*              alt=""*/}
      {/*              src="../checkmarkcircle13.svg"*/}
      {/*            />*/}
      {/*            <div className={styles.phng702}>Hội nghị trực tuyến</div>*/}
      {/*          </div>*/}
      {/*          <div className={styles.infor91}>*/}
      {/*            <img*/}
      {/*              className={styles.checkmarkCircleIcon}*/}
      {/*              alt=""*/}
      {/*              src="../checkmarkcircle13.svg"*/}
      {/*            />*/}
      {/*            <div className={styles.phng702}>*/}
      {/*              Cấu hình thời gian lưu dữ liệu*/}
      {/*            </div>*/}
      {/*          </div>*/}

      {/*          <div className={styles.infor91}>*/}
      {/*            <img*/}
      {/*              className={styles.checkmarkCircleIcon}*/}
      {/*              alt=""*/}
      {/*              src="../checkmarkcircle13.svg"*/}
      {/*            />*/}
      {/*            <div className={styles.phng702}>Tích hợp mã hoá riêng</div>*/}
      {/*          </div>*/}
      {/*        </div>*/}
      {/*      </div>*/}
      {/*      <b className={styles.tmHiuThm}>Tìm hiểu thêm</b>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}
    </div>
  );
};

export default PlansContainer;
